import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";

const Header = styled(Box)`
  font: normal normal bold 14px/18px Roboto;
  font-weight: 400;
  padding: 1px 5px;
  height: 20px;
  border-bottom: 0.1px solid #1106411a;
  display: flex;
  min-width: 90px;
  display: flex;
  align-items: center;
  justify-content: start;
  svg.MuiSelect-icon {
    color: white;
  }
`;

/**
 * StyledHeaderCell - A reusable header cell component with dynamic styling
 * @param {Object} props
 * @param {string} props.systemName - The system name to determine styling ("Total" or other)
 * @param {React.ReactNode} props.children - The content to display in the header
 * @param {string} props.variant - Optional variant for different header types ("adr" for ADR headers)
 * @param {Object} props.style - Additional custom styles to override
 */
export const StyledHeaderCell = ({ systemName, children, variant, style = {} }) => {
  const variantStyles = {
    adr: {
      background: systemName !== "Total" ? "#d6e2f2" : "#306fbc",
    },
    default: {
      background: systemName !== "Total" ? "#fff" : "#306fbc",
    },
  };

  const variantStyle = variantStyles[variant] || variantStyles.default;

  const defaultStyle = {
    ...variantStyle,
    color: systemName !== "Total" ? "#000" : "#fff",
    height: "30px",
    borderRight: "1.5px solid #1106411a",
    borderLeft: "1.5px solid #1106411a",
    borderBottom: "1.5px solid #1106411a",
    ...style,
  };

  return <Header style={defaultStyle}>{children}</Header>;
};
